import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Projects } from '../components/Projects';
import { Phases } from '../components/Phases';
import { Services } from '../components/Services';
import { Partners } from '../components/Partners';
import { ContactBand } from '../components/ContactBand';
export function Home() {
  return <main data-id="element-199" data-mp="1zhxlifrhav0f">
      <Hero data-id="element-200" data-mp="1zi7e8b3wrg9t" />
      <About data-id="element-201" data-mp="1ziqulndwtwlq" />
      <Projects data-id="element-202" data-mp="1ziz558mk8ptr" />
      <Phases data-id="element-203" data-mp="1zjihm9tfym0e" />
      <Services data-id="element-204" data-mp="1zk1zjqj3daef" />
      <Partners data-id="element-205" data-mp="24h0rq3j7379z" />
      <ContactBand data-id="element-206" data-mp="24gijs9n674m8" />
    </main>;
}